"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const mobx_react_1 = require("mobx-react");
const react_hook_form_1 = require("react-hook-form");
const SearchControlSection_1 = __importDefault(require("@Components/Search/SearchWithCriteria/SearchControlSection"));
const SearchCriteriaSection_1 = __importDefault(require("@Components/Search/SearchWithCriteria/SearchCriteriaSection"));
const map_criteria_to_object_1 = require("@App/helpers/map-criteria-to-object");
const is_not_empty_string_1 = require("@App/helpers/is-not-empty-string");
const Sidebar_1 = require("../../Sidebars/Sidebar");
const Button_1 = require("@Components/Buttons/Button");
const common_1 = require("@Const/common");
const clsx_1 = __importDefault(require("clsx"));
const FilterSection_1 = __importDefault(require("@Components/Search/SearchWithCriteria/FilterSection"));
/**
 * @template {object} T - The record type for the "criteria" portion of the form
 * @template {Record<string,unknown>} K - The record type for the "filter" portion of the form
 */
const SearchWithCriteria = (props) => {
    const { searchCriteriaStore, canAddCriteria, resetSearchFn, handleSearch, filterFieldCollections, disableSearchButtons, orientation = 'column', extraButtons, isUniqueTooltip, defaultFilterValues, disableAutoComplete, } = props;
    const [isSidebarOpen, setIsSidebarOpen] = (0, react_1.useState)(false);
    const [filterCount, setFilterCount] = (0, react_1.useState)(0);
    const methods = (0, react_hook_form_1.useForm)({
        defaultValues: { search: [] },
    });
    const onReset = () => {
        if (resetSearchFn) {
            resetSearchFn();
            methods.reset({ search: [], filter: defaultFilterValues !== null && defaultFilterValues !== void 0 ? defaultFilterValues : undefined });
        }
    };
    const onFilterButtonClick = () => {
        setIsSidebarOpen(false);
        methods.handleSubmit(onSubmit)();
    };
    /* Process data from arrays of SearchCriterion to the given generic datastructure (T) */
    const onSubmit = (data) => {
        // Delete empty keys from filter object
        if (data.filter) {
            const entries = Object.entries(data.filter);
            data.filter = Object.fromEntries(entries.filter(([_, value]) => (0, is_not_empty_string_1.isNotEmptyStringUndefinedOrNull)(value)));
        }
        handleSearch(Object.assign({}, (0, map_criteria_to_object_1.mapCriteriaToObject)(data.search)), Object.assign({}, data.filter));
    };
    const onFilterValueChange = (filter) => {
        if (filter) {
            const activeFilters = Object.entries(filter).filter(([, value]) => value && (!Array.isArray(value) || value.length > 0));
            setFilterCount(activeFilters.length);
        }
        props.handleFilterValueChange && props.handleFilterValueChange(filter);
    };
    return (react_1.default.createElement("div", { className: 'search-criteria' },
        react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, methods),
            react_1.default.createElement("form", { onSubmit: methods.handleSubmit(onSubmit), "aria-label": 'Search Form' },
                react_1.default.createElement(SearchCriteriaSection_1.default, { searchCriteriaStore: searchCriteriaStore, canAddCriteria: canAddCriteria, orientation: orientation, isUniqueTooltip: isUniqueTooltip, disableAutoComplete: disableAutoComplete }),
                react_1.default.createElement("div", { className: (0, clsx_1.default)('sidebar-wrapper', isSidebarOpen ? 'open' : 'closed') }, filterFieldCollections && (react_1.default.createElement(Sidebar_1.Sidebar, { onClose: () => setIsSidebarOpen(false) },
                    react_1.default.createElement(FilterSection_1.default, { filterCollections: filterFieldCollections, handleFilterValueChange: onFilterValueChange, onApplyFilter: onFilterButtonClick, onResetFilter: onFilterButtonClick })))),
                !isSidebarOpen && filterFieldCollections && (react_1.default.createElement("div", { className: 'sidebar-button-row' },
                    react_1.default.createElement(Button_1.Button, { type: 'secondary', className: 'sidebar-button', onClick: () => {
                            setIsSidebarOpen(true);
                        }, mainColor: true, submitType: 'button' },
                        react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("span", { className: 'button-text' },
                                "Filters (",
                                filterCount,
                                ")"),
                            react_1.default.createElement("img", { alt: 'filter', src: common_1.ICONS.filter }))))),
                react_1.default.createElement(SearchControlSection_1.default, { searchCriteriaStore: searchCriteriaStore, resetSearchFn: resetSearchFn ? onReset : undefined, disableSearchButtons: disableSearchButtons, extraButtons: extraButtons })))));
};
exports.default = (0, mobx_react_1.observer)(SearchWithCriteria);
